
export class RegulatorPubTypeModel {
  regulator: string;
  pubType: Array<PubTypeList>;

  constructor() {
    this.regulator = '';
    this.pubType = [];
  }
}
export class PubTypeList {
  title: string;
  isActive: boolean;
  updatesDB_Id!: number;

  constructor() {
    this.title = '';
    this.isActive = false;
  }
}
